import React from "react";
import loading from "../images/loading.gif";
const Overlay = () => {
  return (
    <div id="overlay">
      <img src={loading} />{" "}
    </div>
  );
};
export default Overlay;



// WEBPACK FOOTER //
// ./src/utility/overlay.js